import { Controller } from "@hotwired/stimulus";

// The due date of an expense follows the payment terms of the supplier
// chosen: its date plus the supplier's days. A due date typed by hand is
// kept when the date of the expense moves; choosing a supplier sets it again.
//
// <div data-controller="supplier-terms">
//   <input data-supplier-terms-target="date" data-action="change->supplier-terms#follow">
//   <input data-supplier-terms-target="dueDate">
//   <select data-supplier-terms-target="supplier" data-action="change->supplier-terms#apply">
//     <option value="7" data-terms-days="10">…</option>
export default class extends Controller {
  static targets = ["date", "dueDate", "supplier"];

  // The supplier has just been chosen: its terms give the due date.
  apply() {
    const due = this.dueFromTerms();
    if (!due) return;

    this.given = due;
    const picker = this.dueDateTarget._flatpickr;
    if (picker) picker.setDate(due, true);
    else this.dueDateTarget.value = due;
  }

  // The date of the expense moved: the due date follows only while it is
  // still the one the terms gave.
  follow() {
    if (this.given && this.dueDateTarget.value === this.given) this.apply();
  }

  // @returns {string|null} YYYY-MM-DD, null without a date or without terms
  dueFromTerms() {
    const days = this.supplierTarget.selectedOptions[0]?.dataset.termsDays;
    const from = this.dateTarget.value;
    if (days === undefined || days === "" || !/^\d{4}-\d{2}-\d{2}$/.test(from)) return null;

    const due = new Date(`${from}T00:00:00Z`);
    due.setUTCDate(due.getUTCDate() + Number(days));
    return due.toISOString().slice(0, 10);
  }
}
